import {DOM} from "../../../../public/js/utils/DOM";

export namespace ControlsGeneralEasyFilterControl {

    export interface EasyFilterControlProps {
        easyFilterId: string,
        callback: (actionTypeId: number, event: MouseEvent) => void
    }

    class Config {
        public static readonly component: string = 'easyFilter';
        public static readonly itemClassName: string = "EasyFilterControl-content-item";
        public static readonly typeIdDataName: string = "type";
        public static readonly activeClassName = "active";
    }

    export class Control {

        public static initialize(props: EasyFilterControlProps) : void {
            this.triggerActions(props);
        }

        public static getEasyFilterType(easyFilterId: string): number {

            const easyFilter = DOM.Parser.getHtmlElement(easyFilterId);
            const active = DOM.Parser.getHtmlElementByClass(Config.activeClassName, easyFilter);
            return parseInt(DOM.Parser.getDataByNameFromElement(Config.typeIdDataName, active));
        }

        private static triggerActions(props: EasyFilterControlProps) {

            const easyFilter = DOM.Parser.getHtmlElement(props.easyFilterId);
            const triggers = DOM.Parser.getHtmlElements(Config.itemClassName, easyFilter);
            for (let i = 0; i < triggers.length; i++) {
                const trigger = triggers[i];
                const typeId = parseInt(DOM.Parser.getDataByNameFromElement(Config.typeIdDataName, trigger));
                trigger.addEventListener('click', (event: MouseEvent) => {
                    event.preventDefault();
                    event.stopPropagation();
                    props.callback(typeId, event)
                })
            }
        }
    }
}